import {employees} from "../actions/types"

const defaultEmployeesData = {
	data: [],
	redirectUrl: null,
	isLoading: true,
	hasError: false,
	error: null,
	isShowing: false,
	isLoadingActions: false,
	isSavingPermissions: false,
	isRedirecting: false,
	isExporting: false,
	isDeleting: false,
	isRestoring:false,
	isValidating:false,
	isArchiving:false,
	isunArchiving:false,
	filters: [],
	meta: {
		pagination: {
			total: 0,
			count: 0,
			per_page: 15,
			current_page: 1,
			total_pages: 1,
		}
	}
}

const employeesReducer = (state = defaultEmployeesData, action = []) => {
	switch (action.type) {

	case employees.GET_EMPLOYEES_STARTED:
		return { ...state, isLoading: true }

	case employees.GET_EMPLOYEES_SUCCESS:

		// if(action.payload.filterClick === true) {
		// 	// console.log("action.payload", action.payload.data.map(dat => dat.abilities.reverse()))
		// }
		if (action.payload)
			return { ...state, ...action.payload, isLoading: false }

		return state

	case employees.GET_EMPLOYEES_ERROR:
		return { ...state, isLoading: false, hasError: true }

	case employees.SHOW_EMPLOYEES_STARTED:
		return { ...state, isShowing: true }

	case employees.SHOW_EMPLOYEES_SUCCESS:
		if (!action.payload.id)
			return state
		if (state.data.find(item => (item.id === action.payload.id)))
			return { ...state, isShowing: false, data: state.data.map(item => (item.id === action.payload.id ? action.payload : item)) }
		return { ...state, data: [...state.data, action.payload], isShowing: false }

	case employees.SHOW_EMPLOYEES_ERROR:
		return { ...state, isShowing: false, hasError: true }

	case employees.CREATE_EMPLOYEES_STARTED:
		return { ...state, isSaving: true }

	case employees.CREATE_EMPLOYEES_SUCCESS:
		if (action.payload)
			return {
				...state,
				data: [...state.data, { ...action.payload.data }],
				isSaving: false
			}
		return state

	case employees.CREATE_EMPLOYEES_ERROR:
		return { ...state, isSaving: false, hasError: true }


	case employees.DELETE_EMPLOYEES_STARTED:
		return {...state, isDeleting:true}

	case employees.DELETE_EMPLOYEES_SUCCESS:
		if (action.payload)
			return {...state, data: state.data.filter(item => (item.id !== action.payload.id)), isDeleting: false}
		return state

	case employees.DELETE_EMPLOYEES_ERROR:
		return { ...state, isDeleting:false, hasError:true }


		case employees.ARCHIVE_EMPLOYEES_STARTED:
		return {...state, isArchiving:true}

	case employees.ARCHIVE_EMPLOYEES_SUCCESS:
		if (action.payload){
			let getEmployee = state.data.find(item => (item.id == action.payload.id));
			getEmployee.archived = true;
			return {...state, isArchiving: false}
		}
		return state

	case employees.ARCHIVE_EMPLOYEES_ERROR:
		return { ...state, isArchiving:false, hasError:true }


		case employees.UNARCHIVE_EMPLOYEES_STARTED:
		return {...state, isunArchiving:true}

	case employees.UNARCHIVE_EMPLOYEES_SUCCESS:
		if (action.payload){
			let getEmployee = state.data.find(item => (item.id == action.payload.id));
			getEmployee.archived = false;
			return {...state, isunArchiving: false} 
		}
		return state

	case employees.UNARCHIVE_EMPLOYEES_ERROR:
		return { ...state, isunArchiving:false, hasError:true }

	default:
		return state
	}
}


export default employeesReducer
